import { render, staticRenderFns } from "./Isi.vue?vue&type=template&id=33a4bd1d&"
import script from "./Isi.vue?vue&type=script&lang=js&"
export * from "./Isi.vue?vue&type=script&lang=js&"
import style0 from "./Isi.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports